<div class="header-container" [style.direction]="authService.language.direction">
  <h5
    [ngClass]="{
      'text-center': true,
      'header-static-color': staticColor,
      'text-success': !staticColor && !authService.formHasErrors(parentComponent),
      'text-danger': !staticColor && authService.showAlertMessage(parentComponent),
    }"
  >
    <i [class]="`${iconsStyle} ${icon}`"></i>
    {{ title | translate }}
  </h5>
  @if (content && !authService.actionSucceeded(parentComponent)) {
    <span [innerHTML]="content | translate"> </span>
  }
</div>
